
import { Options, Vue } from "vue-class-component";
import { downloadCsvFromCsvContent } from "@/app/infrastructures/misc/Utils";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import { BulkDownloadController } from "@/app/ui/controllers/BulkDownloadController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PodDexController } from "@/app/ui/controllers/PodDexController";
import { ReasonListDex } from "@/data/payload/api/PodDexRequest";
import { ReasonData } from "@/domain/entities/PodDex";
import { FlagsBulkDownloadData } from "@/feature-flags/flags-bulk-download-data";
import { FlagsBulkDownloadTemplate } from "@/feature-flags/flags-bulk-download-template";

@Options({
  components: {
    DetailLayout
  }
})
export default class TabExistingData extends Vue {
  //   Search
  searchValue = "";
  onSearch(value: string) {
    this.searchValue = value;
  }
  onClearSearch() {
    this.searchValue = "";
  }

  get filteredStepFillTemplate() {
    return this.tempList.filter((item) =>
      this.searchValue
        ? item.title.toLowerCase().includes(this.searchValue.toLowerCase())
        : true
    );
  }

  get accountType() {
    return AccountController.accountData.account_type;
  }
  get detailAccountType() {
    return AccountController.accountData.account_type_detail.type;
  }

  stepFillTemplate = [
    {
      title: "Permission List",
      description: "Data Permision List",
      service: "horde/v1",
      type: "account/role/permission/list/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_permission_list.isEnabled()
    },
    {
      title: "Role",
      description: "Data Role",
      service: "horde/v1",
      type: "account/role/list/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_role.isEnabled()
    }
  ];

  internalTemplate = [
    {
      title: "eCargo Commodity",
      description: "Data eCargo Commodity",
      service: "horde/v1",
      type: "commodity/group/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_ecargo_commody.isEnabled()
    },
    {
      title: "Commodity",
      description: "Data commodity",
      service: "horde/v1",
      type: "commodity/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_commody.isEnabled()
    },
    {
      title: "Location Country",
      description: "Data location country",
      service: "horde/v1",
      type: "country/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_location_country.isEnabled()
    },
    {
      title: "Location City",
      description: "Data location city",
      service: "horde/v1",
      type: "city/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_location_city.isEnabled()
    },
    {
      title: "Location District",
      description: "Data location district",
      service: "horde/v1",
      type: "district/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_location_district.isEnabled()
    },
    {
      title: "Vendor",
      description: "Data vendor",
      service: "horde/v1",
      type: "vendor/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_vendor.isEnabled()
    },
    {
      title: "Transport Vendor",
      description: "Data Transaport Vendor",
      service: "horde/v1",
      type: "transport/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_transport_vendor.isEnabled()
    },
    {
      title: "Leg",
      description: "Data Leg",
      service: "horde/v1",
      type: "leg/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_leg.isEnabled()
    },
    {
      title: "Route",
      description: "Data Route",
      service: "horde/v1",
      type: "route/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_leg_route.isEnabled()
    },
    {
      title: "Route Leg",
      description: "Data Route Leg",
      service: "horde/v1",
      type: "route/route-leg/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_routeleg.isEnabled()
    },
    {
      title: "SLA District",
      description: "Data SLA District",
      service: "horde/v1",
      type: "district/export_csv/sla",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_sla_district.isEnabled()
    },
    {
      title: "SLA City",
      description: "Data SLA City",
      service: "horde/v1",
      type: "estimate/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_sla_city.isEnabled()
    },
    {
      title: "Cargo Config",
      description: "Data Cargo Config",
      service: "horde/v1",
      type: "cargo-configuration/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_cargo_config.isEnabled()
    },
    {
      title: "AWB Reserve",
      description: "Data AWB Reserve",
      service: "hydra/v1",
      type: "cargo-reserve/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_awb_reserve.isEnabled()
    },
    {
      title: "Region",
      description: "Data Region",
      service: "horde/v1",
      type: "region/export-csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_region.isEnabled()
    },
    {
      title: "Region City",
      description: "Data Region City",
      service: "horde/v1",
      type: "region/region-city/export-csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_region_city.isEnabled()
    },
    {
      title: "Kargo Grouping",
      description: "Data Kargo Grouping",
      service: "horde/v1",
      type: "rtc_city_group/export_csv",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_kargo_grouping.isEnabled()
    },
    {
      title: "Reason HALCD",
      description: "Data Reason HALCD",
      service: "hydra/v1/reason",
      type: "",
      featureFlag: FlagsBulkDownloadData.bulk_action_download_data_reason_hal_cd.isEnabled()
    },
    {
      title: "COD Restriction",
      description: "Data COD Restriction",
      service: "horde/v1",
      type: "cod-restriction/export_csv",
      cardTestId: "bulk-download-existing-data-cod-restriction-config",
      downloadTestId: "bulk-download-existing-data-card-cod-restriction-config-download",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_cod_restriction.isEnabled()
    },
    {
      title: "Duty Tax",
      description: "Data Duty Tax",
      service: "horde/v1",
      type: "duty_tax_configuration/export_csv",
      cardTestId: "bulk-download-existing-data-card-duty-tax",
      downloadTestId: "bulk-download-existing-data-card-duty-tax-download",
      featureFlag: FlagsBulkDownloadTemplate.bulk_action_download_template_duty_tax.isEnabled()
    },
  ];

  get tempList() {
    if (this.accountType) {
      if (this.accountType === "internal") {
        return [...this.stepFillTemplate, ...this.internalTemplate];
      }
      if (this.accountType === "client" || this.detailAccountType === "pos") {
        return [
          ...this.stepFillTemplate,
          this.internalTemplate[1],
          this.internalTemplate[4]
        ];
      }
      return this.stepFillTemplate;
    }
    return [];
  }

  errorExport = false;
  async downloadExisting(service: string, type: string, title: string) {
    MainAppController.showLoading();

    let resp = {
      success: false,
      data: ""
    };
    if (title === "Reason HALCD") {
      await PodDexController.getReasonList(
        new ReasonListDex({
          statusCode: "HALCD",
          reasonStatus: "active"
        })
      );
      const header = "reason_code,reason_description";
      const data = PodDexController.reasonList.map(
        (item: ReasonData) => `${item.reasonCode},${item.reasonDescription}`
      );

      resp = {
        success: true,
        data: [header, ...data].join("\n")
      };
    } else {
      resp = await BulkDownloadController.getExistingData({
        service: service,
        type: type
      });
    }
    MainAppController.closeLoading();
    this.errorExport = !resp.success;
    if (resp.success) {
      downloadCsvFromCsvContent({
        fileName: `${title}.csv`,
        csvContent: resp.data
      });
    }
  }
}
